export default __webpack_public_path__ + "static/media/resume.8188ca86.pdf";